(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.kore-swatch');
    if (!btn) return;
    var wrapper = btn.closest('.card-wrapper');
    if (!wrapper) return;
    var mainImg = wrapper.querySelector('.card__media .media img');
    if (!mainImg) return;
    var newSrc = btn.dataset.variantImg;
    if (!newSrc) return;
    mainImg.src = newSrc;
    mainImg.srcset = newSrc;
    btn.closest('.kore-swatches').querySelectorAll('.kore-swatch').forEach(function (s) {
      s.classList.remove('is-active');
    });
    btn.classList.add('is-active');
  });
})();
